import { PackagingComponentExportProfileDto } from '../entities/component-entities/packaging-component-export-profile-dto';
import { PackagingUnitExportProfileDto } from '../entities/packaging-unit-entities/packaging-unit-export-profile-dto';
import { ParentApiService } from './parent-api-service';
import { Observable, firstValueFrom, map, of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PackagingSystemExportProfileDto } from '../entities/packaging-system-entities/packaging-system-export-profile-dto';
import { ExportInfoDto } from '../entities/export-info-dto';
import { ImportCandidateDto } from '../entities/import-candidate-dto';
import { CompositeMaterialExportProfileDto } from '../entities/material-entities/composite-material-export-profile-dto';
import { PackagingPart } from 'src/app/model/packaging-part-enum';
import { PaginationQueryDto } from '../entities/pagination-query-dto';
import { PaginationResponseDto } from '../entities/pagination-response-dto';
import { OrganizationDto } from '../entities/organization-dto';
import { ChangeReferenceDto } from '../entities/change-reference-dto';

@Injectable({ providedIn: 'root' })
export class ImportExportApiService extends ParentApiService {

  private _newMaterialCandidateCount: number = 0;
  private _newComponentCandidateCount: number = 0;
  private _newUnitCandidateCount: number = 0;
  private _newSystemCandidateCount: number = 0;
  private _newMaterialTrackingCount: number = 0;
  private _newComponentTrackingCount: number = 0;
  private _newUnitTrackingCount: number = 0;
  private _newSystemTrackingCount: number = 0;

  constructor(private http: HttpClient) {
    super();
    this.updateNewImportCandidateCounts()
  }

  get allNotifications(): number {
    let notificationCount : number = 0;
    notificationCount += this._newMaterialCandidateCount > 0 ? 1:0;
    notificationCount += this._newComponentCandidateCount > 0 ? 1:0;
    notificationCount += this._newUnitCandidateCount > 0 ? 1:0;
    notificationCount += this._newSystemCandidateCount > 0 ? 1:0;
    notificationCount += this._newMaterialTrackingCount > 0 ? 1:0;
    notificationCount += this._newComponentTrackingCount > 0 ? 1:0;
    notificationCount += this._newUnitTrackingCount > 0 ? 1:0;
    notificationCount += this._newSystemTrackingCount > 0 ? 1:0;
    return notificationCount;
  }
  get newMaterialCandidateCount() : number {
    return this._newMaterialCandidateCount
  }
  get newComponentCandidateCount() : number {
    return this._newComponentCandidateCount
  }

  get newUnitCandidateCount() : number {
    return this._newUnitCandidateCount
  }
  get newSystemCandidateCount() : number {
    return this._newSystemCandidateCount
  }
  get newMaterialTrackingCount() : number {
    return this._newMaterialTrackingCount
  }
  get newComponentTrackingCount() : number {
    return this._newComponentTrackingCount
  }

  get newUnitTrackingCount() : number {
    return this._newUnitTrackingCount
  }
  get newSystemTrackingCount() : number {
    return this._newSystemTrackingCount
  }


  // Packaging Systems

  public getPackagingSystemExportProfiles(stayOnPageIfError?: boolean): Observable<PackagingSystemExportProfileDto[]> {
    const url = `${environment.webApiAddress}/api/packaging-system-export-profiles`;
    return this.http.get<PackagingSystemExportProfileDto[]>(url, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  public setPackagingSystemExportProfile(dto: PackagingSystemExportProfileDto, stayOnPageIfError?: boolean): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-system-export-profiles`;
    return this.http.put<any>(url, dto, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  public deletePackagingSystemExportProfile(profileId: number): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-system-export-profiles?id=${profileId}`;
    return this.http.delete(url);
  }

  public exportPackagingSystem(
    packagingSystemId: number, principalId: number, psProfileId?: number, puProfileId?: number, stayOnPageIfError?: boolean
  ): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.set('packagingSystemId', packagingSystemId);
    params = params.set('principalId', principalId);
    if (psProfileId != null) { params = params.set('packagingSystemExportProfileId', psProfileId); }
    if (puProfileId != null) { params = params.set('packagingUnitExportProfileId', puProfileId); }
    const url = `${environment.webApiAddress}/api/packaging-systems/export`;
    return this.http.put(url, null, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader, params });
  }

  public importPackagingSystem(
    importCandidateId: number, directoryId: number, tracking: boolean, stayOnPageIfError = true
  ): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.set('importCandidateId', importCandidateId);
    params = params.set('directoryId', directoryId);
    params = params.set('tracking', tracking);
    const url = `${environment.webApiAddress}/api/packaging-systems/import`;
    return this.http.put(url, null, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader, params });
  }

  public getNewPackagingSystemImportCandidatesCount(): Promise<number> {
    const url = `${environment.webApiAddress}/api/packaging-systems/new-import-candidates-count`;
    return firstValueFrom(this.http.get<number>(url));
  }

  public getNewPackagingSystemTrackingCandidatesCount(): Promise<number> {
    const url = `${environment.webApiAddress}/api/packaging-systems/new-tracking-candidates-count`;
    return firstValueFrom(this.http.get<number>(url));
  }

  public putPackagingSystemsImportNotificationsSeen(): Promise<any> {
    const url = `${environment.webApiAddress}/api/packaging-systems/import-notifications-seen`;
    return firstValueFrom(this.http.put(url,null));
  }

  public putPackagingSystemsTrackingtNotificationsSeen(): Promise<any> {
    const url = `${environment.webApiAddress}/api/packaging-systems/tracking-notifications-seen`;
    return firstValueFrom(this.http.put(url,null));
  }

  public deletePackagingSystemImportCandidate(importCandidateId: number): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-systems/import-candidates?importCandidateId=${importCandidateId}`;
    return this.http.delete(url);
  }

  public ignorePackagingSystemChanges(packagingSystemId: number): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-systems/ignore-changes?packagingSystemId=${packagingSystemId}`;
    return this.http.put(url, null);
  }

  public applyPackagingSystemChanges(packagingSystemId: number, stayOnPageIfError = true): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-systems/adopt-changes?packagingSystemId=${packagingSystemId}`;
    return this.http.put(url, null, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  // Packaging Units

  public getPackagingUnitExportProfiles(stayOnPageIfError?: boolean): Observable<PackagingUnitExportProfileDto[]> {
    const url = `${environment.webApiAddress}/api/packaging-unit-export-profiles`;
    return this.http.get<PackagingUnitExportProfileDto[]>(url, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  public setPackagingUnitExportProfile(dto: PackagingUnitExportProfileDto, stayOnPageIfError?: boolean): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-unit-export-profiles`;
    return this.http.put<any>(url, dto, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  public deletePackagingUnitExportProfile(profileId: number): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-unit-export-profiles?id=${profileId}`;
    return this.http.delete(url);
  }

  public exportPackagingUnit(
    packagingUnitId: number, principalId: number, exportProfileId?: number, stayOnPageIfError?: boolean
  ): Observable<any> {
    let url =
      `${environment.webApiAddress}/api/packaging-units/export?packagingUnitId=${packagingUnitId}&principalId=${principalId}`;
    if (exportProfileId != null) {
      url = url.concat(`&exportProfileId=${exportProfileId}`);
    }
    return this.http.put(url, null, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  public importPackagingUnit(importCandidateId: number, directoryId: number, tracking: boolean, stayOnPageIfError = true): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.set('importCandidateId', importCandidateId);
    params = params.set('directoryId', directoryId);
    params = params.set('tracking', tracking);
    const url = `${environment.webApiAddress}/api/packaging-units/import`;
    return this.http.put(url, null, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader, params });
  }

  public getNewPackagingUnitImportCandidatesCount(): Promise<number> {
    const url = `${environment.webApiAddress}/api/packaging-units/new-import-candidates-count`;
    return firstValueFrom(this.http.get<number>(url));
  }

  public getNewPackagingUnitTrackingCandidatesCount(): Promise<number> {
    const url = `${environment.webApiAddress}/api/packaging-units/new-tracking-candidates-count`;
    return firstValueFrom(this.http.get<number>(url));
  }

  public putPackagingUnitImportNotificationsSeen(): Promise<any> {
    const url = `${environment.webApiAddress}/api/packaging-units/import-notifications-seen`;
    return firstValueFrom(this.http.put(url,null));
  }

  public putPackagingUnitTrackingtNotificationsSeen(): Promise<any> {
    const url = `${environment.webApiAddress}/api/packaging-units/tracking-notifications-seen`;
    return firstValueFrom(this.http.put(url,null));
  }

  public deletePackagingUnitImportCandidate(importCandidateId: number): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-units/import-candidates?importCandidateId=${importCandidateId}`;
    return this.http.delete(url);
  }

  public ignorePackagingUnitChanges(packagingUnitId: number): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-units/ignore-changes?packagingUnitId=${packagingUnitId}`;
    return this.http.put(url, null);
  }

  public applyPackagingUnitChanges(packagingUnitId: number, stayOnPageIfError = true): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-units/adopt-changes?packagingUnitId=${packagingUnitId}`;
    return this.http.put(url, null, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  // Components

  public getPackagingComponentExportProfiles(stayOnPageIfError?: boolean): Observable<PackagingComponentExportProfileDto[]> {
    const url = `${environment.webApiAddress}/api/packaging-component-export-profiles`;
    return this.http.get<PackagingComponentExportProfileDto[]>(url, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  public setPackagingComponentExportProfile(dto: PackagingComponentExportProfileDto, stayOnPageIfError?: boolean): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-component-export-profiles`;
    return this.http.put<any>(url, dto, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  public deletePackagingComponentExportProfile(profileId: number): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-component-export-profiles?id=${profileId}`;
    return this.http.delete(url);
  }

  public exportComponents(
    componentId: number, principalId: number, exportProfileId?: number, stayOnPageIfError?: boolean
  ): Observable<any> {
    let url = `${environment.webApiAddress}/api/packaging-components/export?packagingComponentId=${componentId}&principalId=${principalId}`;
    if (exportProfileId != null) {
      url = url.concat(`&exportProfileId=${exportProfileId}`);
    }
    return this.http.put(url, null, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  public importComponents(importCandidateId: number, directoryId: number, tracking: boolean, stayOnPageIfError = true): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.set('importCandidateId', importCandidateId);
    params = params.set('directoryId', directoryId);
    params = params.set('tracking', tracking);
    const url = `${environment.webApiAddress}/api/packaging-components/import`;
    return this.http.put(url, null, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader, params });
  }

  public getNewComponentImportCandidatesCount(): Promise<number> {
    const url = `${environment.webApiAddress}/api/packaging-components/new-import-candidates-count`;
    return firstValueFrom(this.http.get<number>(url));
  }

  public getNewComponentTrackingCandidatesCount(): Promise<number> {
    const url = `${environment.webApiAddress}/api/packaging-components/new-tracking-candidates-count`;
    return firstValueFrom(this.http.get<number>(url));
  }

  public putComponentImportNotificationsSeen(): Promise<any> {
    const url = `${environment.webApiAddress}/api/packaging-components/import-notifications-seen`;
    return firstValueFrom(this.http.put(url,null));
  }

  public putComponentTrackingtNotificationsSeen(): Promise<any> {
    const url = `${environment.webApiAddress}/api/packaging-components/tracking-notifications-seen`;
    return firstValueFrom(this.http.put(url,null));
  }

  public deleteComponentImportCandidate(importCandidateId: number): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-components/import-candidates?importCandidateId=${importCandidateId}`;
    return this.http.delete(url);
  }

  public ignoreComponentChanges(componentId: number): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-components/ignore-changes?packagingComponentId=${componentId}`;
    return this.http.put(url, null);
  }

  public applyComponentChanges(componentId: number, stayOnPageIfError = true): Observable<any> {
    const url = `${environment.webApiAddress}/api/packaging-components/adopt-changes?packagingComponentId=${componentId}`;
    return this.http.put(url, null, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  // Materials

  public getCompositeMaterialExportProfiles(stayOnPageIfError?: boolean): Observable<CompositeMaterialExportProfileDto[]> {
    const url = `${environment.webApiAddress}/api/multi-material-export-profiles`;
    return this.http.get<CompositeMaterialExportProfileDto[]>(url, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  public setCompositeMaterialExportProfile(dto: CompositeMaterialExportProfileDto, stayOnPageIfError?: boolean): Observable<any> {
    const url = `${environment.webApiAddress}/api/multi-material-export-profiles`;
    return this.http.put<any>(url, dto, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  public deleteCompositeMaterialExportProfile(profileId: number): Observable<any> {
    const url = `${environment.webApiAddress}/api/multi-material-export-profiles?id=${profileId}`;
    return this.http.delete(url);
  }

  public exportMaterial(materialId: number, principalId: number, exportProfileId?: number, stayOnPageIfError?: boolean): Observable<any> {
    let url = `${environment.webApiAddress}/api/multi-materials/export?multiMaterialId=${materialId}&principalId=${principalId}`;
    if (exportProfileId != null) {
      url = url.concat(`&exportProfileId=${exportProfileId}`);
    }
    return this.http.put(url, null, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  public importMaterials(importCandidateId: number, directoryId: number, tracking: boolean, stayOnPageIfError = true): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.set('importCandidateId', importCandidateId);
    params = params.set('directoryId', directoryId);
    params = params.set('tracking', tracking);
    const url = `${environment.webApiAddress}/api/multi-materials/import`;
    return this.http.put(url, null, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader, params });
  }

  public getNewMaterialImportCandidatesCount(): Promise<number> {
    const url = `${environment.webApiAddress}/api/multi-materials/new-import-candidates-count`;
    return firstValueFrom(this.http.get<number>(url));
  }

  public getNewMaterialTrackingCandidatesCount(): Promise<number> {
    const url = `${environment.webApiAddress}/api/multi-materials/new-tracking-candidates-count`;
    return firstValueFrom(this.http.get<number>(url));
  }

  public putMaterialImportNotificationsSeen(): Promise<any> {
    const url = `${environment.webApiAddress}/api/multi-materials/import-notifications-seen`;
    return firstValueFrom(this.http.put(url,null));
  }

  public putMaterialTrackingtNotificationsSeen(): Promise<any> {
    const url = `${environment.webApiAddress}/api/multi-materials/tracking-notifications-seen`;
    return firstValueFrom(this.http.put(url,null));
  }

  public deleteMaterialImportCandidate(importCandidateId: number): Observable<any> {
    const url = `${environment.webApiAddress}/api/multi-materials/import-candidates?importCandidateId=${importCandidateId}`;
    return this.http.delete(url);
  }

  public applyMaterialChanges(materialId: number, stayOnPageIfError = true): Observable<any> {
    const url = `${environment.webApiAddress}/api/multi-materials/adopt-changes?multiMaterialId=${materialId}`;
    return this.http.put(url, null, { headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader });
  }

  public ignoreMaterialChanges(materialId: number): Observable<any> {
    const url = `${environment.webApiAddress}/api/multi-materials/ignore-changes?multiMaterialId=${materialId}`;
    return this.http.put(url, null);
  }

  public getExportListByPage<T extends ExportInfoDto<any, any>>(packagingPart: PackagingPart, paginationQuery: PaginationQueryDto): Observable<PaginationResponseDto<T>> {
    let url = `${environment.webApiAddress}/api`;
    switch (packagingPart) {
      case PackagingPart.System:
        url = `${url}/packaging-systems/export-infos/by-page`;
        break;
      case PackagingPart.Unit:
        url = `${url}/packaging-units/export-infos/by-page`;
        break;
      case PackagingPart.Component:
        url = `${url}/packaging-components/export-infos/by-page`;
        break;
      case PackagingPart.Material:
        url = `${url}/multi-materials/export-infos/by-page`;
        break;
    }

    return this.http.post<PaginationResponseDto<T>>(url, paginationQuery).pipe(
      map(response => {
        response.items = response.items.map(item => {
          const exportTimestamp: string = item.exportTimestamp.toString();
          item.exportTimestamp = new Date(exportTimestamp);
          return item;
        });
        return response;
      }),
    );
  }

  public getImportCandidatesByPage<T extends ImportCandidateDto>(packagingPart: PackagingPart, paginationQuery: PaginationQueryDto): Observable<PaginationResponseDto<T>> {
    let url = `${environment.webApiAddress}/api`;
    switch (packagingPart) {
      case PackagingPart.System:
        url = `${url}/packaging-systems/import-candidates/by-page`;
        break;
      case PackagingPart.Unit:
        url = `${url}/packaging-units/import-candidates/by-page`;
        break;
      case PackagingPart.Component:
        url = `${url}/packaging-components/import-candidates/by-page`;
        break;
      case PackagingPart.Material:
        url = `${url}/multi-materials/import-candidates/by-page`;
        break;
    }

    return this.http.post<PaginationResponseDto<T>>(url, paginationQuery).pipe(
      map(response => {
        response.items = response.items.map(item => {
          const exportTimestamp: string = item.exportTimestamp.toString();
          item.exportTimestamp = new Date(exportTimestamp);
          return item;
        });
        return response;
      }),
    );
  }

  public getChangesByPage(packagingPart: PackagingPart, paginationQuery: PaginationQueryDto): Observable<PaginationResponseDto<ChangeReferenceDto>> {
    let url = `${environment.webApiAddress}/api`;
    switch (packagingPart) {
      case PackagingPart.System:
        url = `${url}/packaging-systems/changes/by-page`;
        break;
      case PackagingPart.Unit:
        url = `${url}/packaging-units/changes/by-page`;
        break;
      case PackagingPart.Component:
        url = `${url}/packaging-components/changes/by-page`;
        break;
      case PackagingPart.Material:
        url = `${url}/multi-materials/changes/by-page`;
        break;
    }

    return this.http.post<PaginationResponseDto<ChangeReferenceDto>>(url, paginationQuery);
  }

  public getExportOrganizations(packagingPart: PackagingPart): Observable<OrganizationDto[]> {
    let url = `${environment.webApiAddress}/api`;
    switch (packagingPart) {
      case PackagingPart.System:
        url = `${url}/packaging-systems/export-infos/organizations`;
        break;
      case PackagingPart.Unit:
        url = `${url}/packaging-units/export-infos/organizations`;
        break;
      case PackagingPart.Component:
        url = `${url}/packaging-components/export-infos/organizations`;
        break;
      case PackagingPart.Material:
        url = `${url}/multi-materials/export-infos/organizations`;
        break;
    }

    return this.http.get<OrganizationDto[]>(url);
  }

  public setTrackable(importCandidateId: number, tracking: boolean, packagingPart: PackagingPart) {
    const urlEnd = `set-trackable?importCandidateId=${importCandidateId}&tracking=${tracking}`;
    let url = `${environment.webApiAddress}/api`;
    switch (packagingPart) {
      case PackagingPart.System:
        url = `${url}/packaging-systems/${urlEnd}`;
        break;
      case PackagingPart.Unit:
        url = `${url}/packaging-units/${urlEnd}`;
        break;
      case PackagingPart.Component:
        url = `${url}/packaging-components/${urlEnd}`;
        break;
      case PackagingPart.Material:
        url = `${url}/multi-materials/${urlEnd}`;
        break;
    }

    return this.http.put(url, null);
  }

  public deleteImportCandidate(importCandidateId: number, packagingPart: PackagingPart) {
    const urlEnd = `import-candidates?importCandidateId=${importCandidateId}`;
    let url = `${environment.webApiAddress}/api`;
    switch (packagingPart) {
      case PackagingPart.System:
        url = `${url}/packaging-systems/${urlEnd}`;
        break;
      case PackagingPart.Unit:
        url = `${url}/packaging-units/${urlEnd}`;
        break;
      case PackagingPart.Component:
        url = `${url}/packaging-components/${urlEnd}`;
        break;
      case PackagingPart.Material:
        url = `${url}/multi-materials/${urlEnd}`;
        break;
    }

    return this.http.delete(url);
  }

  public async updateComponentImportCount() {
    this._newComponentCandidateCount = await this.getNewComponentImportCandidatesCount();
  }
  public async updateComponentTrackingCount() {
    this._newComponentTrackingCount = await this.getNewComponentTrackingCandidatesCount();
  }
  public async updatePackagingUnitImportCount() {
    this._newUnitCandidateCount = await this.getNewPackagingUnitImportCandidatesCount();
  }
  public async updatePackagingUnitTrackingCount() {
    this._newUnitTrackingCount = await this.getNewPackagingUnitTrackingCandidatesCount();
  }
  public async updatePackagingSystemImportCount() {
    this._newSystemCandidateCount = await this.getNewPackagingSystemImportCandidatesCount();
  }
  public async updatePackagingSystemTrackingCount() {
    this._newSystemTrackingCount = await this.getNewPackagingSystemTrackingCandidatesCount();
  }
  public async updateMaterialImportCount() {
    this._newMaterialCandidateCount = await this.getNewMaterialImportCandidatesCount();
  }
  public async updateMaterialTrackingCount() {
    this._newMaterialTrackingCount = await this.getNewMaterialTrackingCandidatesCount();
  }

  public async updateNewImportCandidateCounts() {
    this.updateComponentImportCount();
    this.updateComponentTrackingCount();
    this.updatePackagingUnitImportCount();
    this.updatePackagingUnitTrackingCount();
    this.updatePackagingSystemImportCount();
    this.updatePackagingSystemTrackingCount();
    this.updateMaterialImportCount();
    this.updateMaterialTrackingCount();
  }
}
